export default {
    data() {
        return {
            branchText: window.Drupal.t('Branch'),
            brandAndModelText: window.Drupal.t('Brand and model'),
            brandText: window.Drupal.t('Brand'),
            modelText: window.Drupal.t('Model'),
            constructionYearText: window.Drupal.t('Construction year'),
            yearOfConstructionfromText: window.Drupal.t('Year of construction from'),
            mileageText: window.Drupal.t('Mileage'),
            mileageFromText: window.Drupal.t('Mileage from'),
            priceText: window.Drupal.t('Price'),
            priceFromText: window.Drupal.t('Price from'),
            otherOptionsText: window.Drupal.t('Other options'),
            fuelText: window.Drupal.t('Fuel'),
            transmissionText: window.Drupal.t('Transmission'),
            bodyworkText: window.Drupal.t('Bodywork'),
            colorText: window.Drupal.t('Color'),
            numberOfDoorsText: window.Drupal.t('Number of doors'),
            amountOfCilindersText: window.Drupal.t('Amount of cilinders'),
            garageText: window.Drupal.t('Garage'),
            resultsText: window.Drupal.t('results'),
            manufacturerAscendingText: window.Drupal.t('Manufacturer ascending'),
            manufacturerDescendingText: window.Drupal.t('Manufacturer descending'),
            lastPostedDescendingText: window.Drupal.t('Last posted descending'),
            lastPostedAscendingText: window.Drupal.t('Last posted ascending'),
            priceDescendingText: window.Drupal.t('Price descending'),
            priceAscendingText: window.Drupal.t('Price ascending'),
            yearOfConstructionAscendingText: window.Drupal.t('Year of construction ascending'),
            yearOfConstructionDescendingText: window.Drupal.t('Year of construction descending'),
            mileageAscendingText: window.Drupal.t('Mileage ascending'),
            mileageDescendingText: window.Drupal.t('Mileage descending'),
            noResultsText: window.Drupal.t('No results'),
            adjustFiltersText: window.Drupal.t('No results, adjust the filters.'),
            sortText: window.Drupal.t('Sort'),
            filterText: window.Drupal.t('Filter'),
            resetFiltersText: window.Drupal.t('Reset filters'),
            phoneText: window.Drupal.t('Phone'),
            emailText: window.Drupal.t('Email'),
            fromText: window.Drupal.t('From'),
            advancedSearchText: window.Drupal.t('Advanced search'),
            filterResultsText: window.Drupal.t('Dit filter heeft maar 1 resultaat'),
            toText: window.Drupal.t('To'),
            findYourCarprofText: window.Drupal.t('Find your CarProf'),
            getCurrentLocationText: window.Drupal.t('Get current location'),
            locationsText: window.Drupal.t('locations'),
            closeToYouText: window.Drupal.t('close to you'),
            loadingText: window.Drupal.t('loading...'),
            searchByCityOrZipCodeText: window.Drupal.t('Search by city or zip code'),
            chooseGarageText: window.Drupal.t('Choose garage'),
            listViewText: window.Drupal.t('List view'),
            cardViewText: window.Drupal.t('Card view'),
            goToCompanyPageText: window.Drupal.t('Go to company page'),
            sendAnEmailText: window.Drupal.t('Send an email'),
            backText: window.Drupal.t('Back'),
        }
    }
}